module.exports = __webpack_public_path__ + "img/weektodo-isologo-white.1686696b.svg";